import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { HighLight } from '../../../common/hightLight'
import { StandardComponent } from '../../../standardComponentScore/standardUser'
import { getRiskScaleInterpretationThunk } from '../../store/thunk'
import Commentary from './components/commentary'
import CorporateLinkageScore from './components/corporateLinkageScore'
import CorporateRiskScore from './components/corporateRiskScore'
import DistributionOfScore from './components/distributionOfScore'
import ForwardLookingPDTermStructure from './components/forwardLookingPDTermStructure'
import RiskComponentAnalysis from './components/riskComponentAnalysis'
import RiskScaleAndInterpretation from './components/riskScaleAndInterpretation'
import classes from './index.module.scss'

export const BottomComponent = ({ isAllow }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getRiskScaleInterpretationThunk({}))
  }, [locale])

  return (
    <>
      {isAllow ? (
        <div>
          <Element
            className={classes.hightLightMain}
            style={{
              borderColor: '#E5E5E8',
            }}
          >
            <HighLight />
          </Element>
          <RiskScaleAndInterpretation />
          <CorporateRiskScore />
          <RiskComponentAnalysis />
          <Commentary />
          <ForwardLookingPDTermStructure />
          <DistributionOfScore />
          <CorporateLinkageScore />
        </div>
      ) : (
        <StandardComponent />
      )}
    </>
  )
}
